module.exports = __webpack_public_path__ + "static/media/blog-administracion-sistemas-programacion-1000.cc066747.jpg";